<div class="ep-prompt">
  @switch (phase()) {
    @case ('prompt') {
      <div class="ep-header">
        <div class="ep-icon">
          <i class="material-symbols-rounded">electric_bolt</i>
        </div>
        <h2 class="ep-title">Some bills have suppliers</h2>
        <p class="ep-description">
          {{ supplierBillRows.length }} bill{{ supplierBillRows.length !== 1 ? 's' : '' }}
          {{ supplierBillRows.length !== 1 ? 'are' : 'is' }} with a supplier and
          {{ supplierBillRows.length !== 1 ? 'need' : 'needs' }} energy plan decisions.
        </p>
      </div>

      <!-- Bill summary table -->
      <div class="ep-table">
        <div class="ep-table-header">
          <span class="col-meter">Meter</span>
          <span class="col-period">Bill Period</span>
          <span class="col-supplier">Supplier</span>
          <span class="col-confidence">Confidence</span>
        </div>
        @for (row of supplierBillRows; track row.billGroupId) {
          <div class="ep-table-row">
            <span class="col-meter">{{ row.meterUan }}</span>
            <span class="col-period">{{ row.billPeriod }}</span>
            <span class="col-supplier">{{ row.supplierName }}</span>
            <span class="col-confidence">
              <span class="confidence-badge" [class.high]="row.confidence >= 0.8" [class.low]="row.confidence < 0.8">
                {{ (row.confidence * 100) | number:'1.0-0' }}%
              </span>
            </span>
          </div>
        }
      </div>

      <!-- Warning -->
      <div class="ep-warning">
        <i class="material-symbols-rounded">warning</i>
        <div>
          <span class="eyebrow">Heads up</span>
          <p class="prose">Energy plans are required for rate checks. Without a plan, you risk double-booking a meter into two contracts.</p>
        </div>
      </div>

      <!-- Choice buttons -->
      <div class="ep-actions">
        <button class="choice-card set-now-card" (click)="chooseSetNow()">
          <div class="choice-icon">
            <i class="material-symbols-rounded">edit_note</i>
          </div>
          <div class="choice-body">
            <span class="choice-title">Set Energy Plans Now</span>
            <span class="choice-desc">Select energy plans for each supplier bill before importing.</span>
          </div>
          <i class="material-symbols-rounded choice-arrow">arrow_forward</i>
        </button>

        <button class="choice-card draft-card" (click)="chooseImportDraft()">
          <div class="choice-icon">
            <i class="material-symbols-rounded">draft</i>
          </div>
          <div class="choice-body">
            <span class="choice-title">Import Plan(s) as Drafts</span>
            <span class="choice-desc">Create draft energy plans. Finalize them later from contract management.</span>
          </div>
          <i class="material-symbols-rounded choice-arrow">arrow_forward</i>
        </button>
      </div>

      <div class="ep-back-row">
        <button class="btn-secondary" (click)="goBack()">
          <i class="material-symbols-rounded">arrow_back</i>
          Back
        </button>
      </div>
    }

    @case ('select') {
      <div class="ep-header">
        <h2 class="ep-title">Select Energy Plans</h2>
        <p class="ep-description">Choose an energy plan for each supplier bill.</p>
      </div>

      <div class="ep-select-table">
        @for (row of supplierBillRows; track row.billGroupId) {
          <div class="ep-select-row">
            <div class="row-info">
              <span class="row-meter">{{ row.meterUan }}</span>
              <span class="row-period">{{ row.billPeriod }}</span>
              <span class="row-supplier">{{ row.supplierName }}</span>
            </div>
            <div class="row-select">
              @if (row.loading) {
                <mat-spinner diameter="20"></mat-spinner>
              } @else {
                @if (row.energyPlanOptions.length > 0) {
                  <app-score-select
                    label="Energy Plan"
                    [options]="row.energyPlanOptions"
                    [value]="row.selectedEnergyPlanId ?? null"
                    (valueChange)="onEnergyPlanChange(row, $event)">
                  </app-score-select>
                } @else {
                  <span class="no-plans">No plans available</span>
                }
                @if (!row.selectedEnergyPlanId) {
                  <button class="create-plan-btn" (click)="openCreatePlanDialog(row)">
                    <i class="material-symbols-rounded">add</i>
                    Create New Plan
                  </button>
                }
              }
            </div>
          </div>
        }
      </div>

      <div class="ep-select-actions">
        <button class="btn-secondary" (click)="goBack()">
          <i class="material-symbols-rounded">arrow_back</i>
          Back
        </button>
        <button
          class="btn-primary"
          (click)="continueWithPlans()"
          [disabled]="anyLoading || !allPlansSelected">
          Continue to Import
          <i class="material-symbols-rounded">arrow_forward</i>
        </button>
      </div>
    }

    @case ('creating-drafts') {
      <div class="ep-header">
        <h2 class="ep-title">Creating draft energy plans</h2>
        <p class="ep-description">Setting up draft plans for your supplier bills...</p>
      </div>
      <div class="ep-creating">
        <mat-spinner diameter="40"></mat-spinner>
      </div>
      @if (draftError) {
        <div class="ep-error">
          <i class="material-symbols-rounded">error</i>
          <span>{{ draftError }}</span>
        </div>
      }
    }
  }
</div>
